import { reactive, provide, inject } from 'vue';
import { PsProvider } from '../core/PsProvider';
import PsApiService from '@/api/PsApiService';
import Address from '@/object/Address';
import PsResource from '@/api/common/PsResource';
import AddToCartParameterHolder from '@/object/holder/AddToCartParameterHolder';

export class GetAddressProvider extends PsProvider {

    isNoMoreRecord = reactive<Boolean>(false);
    GetAddressItemList = reactive<PsResource<Address[]>>(new PsResource());
    item = reactive<PsResource<Address>>(new PsResource());
    loading = reactive({
        value: false
    });

    limit: Number = 10;
    offset: Number = 0;

    id: string = "";
  static GetAddressItemList: any;

    private updateItemList(responseData: PsResource<Address[]>) {

        if (this.GetAddressItemList != null
            && this.GetAddressItemList.data != null
            && this.GetAddressItemList.data.length > 0
            && this.offset != 0) {

            if (responseData.data != null && responseData.data.length > 0) {
                this.GetAddressItemList.data.push(...responseData.data);
            }else {
                this.isNoMoreRecord = true;
            }
            this.GetAddressItemList.code = responseData.code;
            this.GetAddressItemList.status = responseData.status;
            this.GetAddressItemList.message = responseData.message;

        } else {

            this.GetAddressItemList = responseData;


        }

        if (this.GetAddressItemList != null && this.GetAddressItemList.data != null) {
            this.offset = this.GetAddressItemList.data.length;
        }
           console.log(this.GetAddressItemList)
    }
    async loadItem(itemId: string, loginUserId: string) {

        this.loading.value = true;
        
        this.item = await PsApiService.getItemDetail<Address>(new Address(), itemId, loginUserId);
    
        this.loading.value = false;

        return this.item;

    }

    async defaultAddress( loginUserId: string, AddressId: string) {

        this.loading.value = true;
        
        this.item = await PsApiService.defualtAddress<Address>(new Address(), loginUserId,AddressId);
    
        this.loading.value = false;

        return this.item;

    }
    async loadGetAddressItemList( loginUserId: string) {

        this.loading.value = true;

        this.offset = 0;
        
        const responseData = await PsApiService.getAddress<Address>(new Address(), loginUserId);
        console.log(responseData,"data-=-=")
        this.updateItemList(responseData);

        this.loading.value = false;
         return responseData
    }

   
    async resetGetAddressItemList(loginUserId: string) {

        this.offset = 0;

        this.loading.value = true;

        const responseData = await PsApiService.getAddress<Address>(new Address(), loginUserId);

        this.updateItemList(responseData);

        this.loading.value = false;

        return this.item;

    }

    async deleteAddress(addressId: string) {

        this.offset = 0;

        this.loading.value = true;

        const responseData = await PsApiService.deleteAddress<Address>(new Address(), addressId);

        this.updateItemList(responseData);

        this.loading.value = false;

        return this.item;

    }
    async postAddToCart(itemId, userId) {
        const parmaHolder = new AddToCartParameterHolder;
        parmaHolder.itemId = itemId;
        parmaHolder.userId = userId;

        const responseData = await PsApiService.postAddToCart<Address>(new Address(),  parmaHolder.toMap());
        
        return responseData;
    }

}

export const GetAddressProviderSymbol = Symbol('GetAddressItemProvider')
export const createGetAddressProviderState = () => {
    return reactive(new GetAddressProvider())
}
export const loadGetAddressItemList = () => {
    return reactive(new GetAddressProvider())
}

export const useGetAddressProviderState = () => inject(GetAddressProviderSymbol) as GetAddressProvider
export const provideGetAddressProviderState = () => provide(
    GetAddressProviderSymbol,
    createGetAddressProviderState()
)